import type { RecordedCrashDto } from '@roadfootage/api-client'

import {
  formatCrashDateTime,
  formatCrashSeverity,
  formatCrashSource,
  formatCrashType,
  formatNumber
} from '@/utils/format'

// The text lines shared by every place that shows a recorded crash (staff CrashLinkPanel, the upload wizard step).

export function crashSourceAndDate(crash: RecordedCrashDto | null | undefined): string {
  if (!crash) return ''
  return `${formatCrashSource(crash.source)} · ${formatCrashDateTime(crash.crashDateTime, crash.crashTimezone, crash.dateTimePrecision)}`
}

function fatalities(crash: RecordedCrashDto | null | undefined): string {
  const n = crash?.fatalityCount
  if (n === null || n === undefined) return 'fatalities unknown'
  return `${formatNumber(n)} ${n === 1 ? 'fatality' : 'fatalities'}`
}

export function crashSeverityLine(crash: RecordedCrashDto | null | undefined): string {
  return `${formatCrashSeverity(crash?.severity)} · ${fatalities(crash)}`
}

export function crashTypeAndAddress(crash: RecordedCrashDto | null | undefined): string {
  const address = crash?.address?.formattedAddress
  return `${formatCrashType(crash?.crashType)} · ${address || 'Address unknown'}`
}
